import React from 'react';
import Modal from './Modal';
import { Button } from './Kit';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle } = FiIcons;

export default function DncConfirmModal({ isOpen, onConfirm, onCancel, leadName }) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
          <SafeIcon icon={FiAlertTriangle} className="w-5 h-5 text-red-600" />
        </div>
        <div className="flex-1">
          <h2 className="text-base font-semibold text-gray-900">
            Mark as Do Not Contact?
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            You're about to mark{' '}
            <span className="font-medium text-gray-800">{leadName}</span> as{' '}
            <span className="font-semibold text-red-600">Do Not Contact</span>.
            This will prevent future outreach to this lead.
          </p>
          <p className="text-xs text-gray-400 mt-2">
            This action can be reversed by changing the status again.
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
        <Button variant="outline" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" size="sm" onClick={onConfirm}>
          Yes, Mark as DNC
        </Button>
      </div>
    </Modal>
  );
}